/* ==========================================================================
   FoldifyCase — Collection filter controls
   - Injects "Expand / Collapse all" + "Hide filters" toolbar into the sidebar
   - Adds a "Show filters" button to the top sort bar when hidden
   - Persists hidden state in localStorage
   - Runs on DOMContentLoaded, and re-runs when the facet form re-renders
     (Shopify swaps the HTML of the facet form on every filter click).
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'fc_filters_hidden';
  var scopeSelector = '.fc-collection-page';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function getScope() {
    return $(scopeSelector);
  }

  function isHidden() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; }
    catch (e) { return false; }
  }

  function setHidden(v) {
    try {
      if (v) localStorage.setItem(STORAGE_KEY, '1');
      else   localStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* ignore */ }
    var scope = getScope();
    if (!scope) return;
    scope.classList.toggle('fc_filters_hidden', !!v);
  }

  /* -------- toolbar: "Expand all / Collapse all" + "Hide filters" ---------- */
  function buildToolbar() {
    var scope = getScope();
    if (!scope) return;
    // Find the sidebar wrapper (Dawn renders it as aside.facets-wrapper)
    var wrapper = scope.querySelector('.facets-wrapper, aside.facets-wrapper, .facets-container');
    if (!wrapper) return;
    if (wrapper.querySelector('.fc-facets-toolbar')) return; // already injected

    // Find the <details> filter groups
    var details = wrapper.querySelectorAll('details.js-filter, details.facets__disclosure-vertical');
    if (!details.length) return;

    var bar = document.createElement('div');
    bar.className = 'fc-facets-toolbar';

    var toggleAll = document.createElement('button');
    toggleAll.type = 'button';
    toggleAll.className = 'fc-facets-toggle-all';
    toggleAll.setAttribute('aria-label', 'Expand or collapse all filters');

    function syncToggleLabel() {
      var allOpen = Array.from(details).every(function (d) { return d.hasAttribute('open'); });
      toggleAll.textContent = allOpen ? 'Collapse all' : 'Expand all';
    }

    toggleAll.addEventListener('click', function () {
      var allOpen = Array.from(details).every(function (d) { return d.hasAttribute('open'); });
      Array.from(details).forEach(function (d) {
        if (allOpen) d.removeAttribute('open');
        else d.setAttribute('open', '');
      });
      syncToggleLabel();
    });

    // Also update label when user opens/closes individual groups
    Array.from(details).forEach(function (d) {
      d.addEventListener('toggle', syncToggleLabel);
    });

    syncToggleLabel();

    var hide = document.createElement('button');
    hide.type = 'button';
    hide.className = 'fc-facets-hide';
    hide.setAttribute('aria-label', 'Hide filter sidebar');
    hide.textContent = 'Hide';
    hide.addEventListener('click', function () {
      setHidden(true);
    });

    bar.appendChild(toggleAll);
    bar.appendChild(hide);

    // Insert at the top of the sidebar, right after the "Filter" heading if present
    var heading = wrapper.querySelector('.facets__heading, > h2');
    if (heading && heading.parentNode === wrapper) {
      heading.insertAdjacentElement('afterend', bar);
    } else {
      wrapper.insertBefore(bar, wrapper.firstChild);
    }
  }

  /* -------- "Show filters" button (appears in sort bar when hidden) -------- */
  function buildShowButton() {
    var scope = getScope();
    if (!scope) return;
    if (scope.querySelector('.fc-facets-show')) return; // already there

    // Place it inside the sort/count bar
    var sortBar = scope.querySelector('.facets-vertical-sort .facets-vertical-form, .facet-filters.sorting');
    if (!sortBar) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fc-facets-show';
    btn.setAttribute('aria-label', 'Show filter sidebar');
    btn.textContent = 'Show filters';
    btn.addEventListener('click', function () {
      setHidden(false);
    });

    // Insert at the start of the bar so it sits on the left
    sortBar.insertBefore(btn, sortBar.firstChild);
  }

  /* -------- initial state + observer for form re-renders ------------------- */
  function init() {
    var scope = getScope();
    if (!scope) return;

    // Restore hidden state
    if (isHidden()) scope.classList.add('fc_filters_hidden');

    buildToolbar();
    buildShowButton();
  }

  // Dawn's facet-filters-form web component replaces the entire sidebar HTML
  // after each filter click. Watch for that and re-inject.
  function watchForReRender() {
    var scope = getScope();
    if (!scope) return;

    var observer = new MutationObserver(function (mutations) {
      var needsRebuild = false;
      mutations.forEach(function (m) {
        if (m.type === 'childList' && m.addedNodes.length) {
          Array.prototype.forEach.call(m.addedNodes, function (n) {
            if (n.nodeType !== 1) return;
            // If the sidebar or sort bar was swapped out, rebuild
            if (n.matches && (
              n.matches('.facets-wrapper, aside.facets-wrapper, .facets-container, .facets-vertical-sort') ||
              n.querySelector && n.querySelector('.facets-wrapper, aside.facets-wrapper, .facets-container, .facets-vertical-sort')
            )) {
              needsRebuild = true;
            }
          });
        }
      });
      if (needsRebuild) {
        // Let Dawn finish its DOM swap first
        setTimeout(function () {
          buildToolbar();
          buildShowButton();
        }, 50);
      }
    });

    observer.observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      watchForReRender();
    });
  } else {
    init();
    watchForReRender();
  }
})();
